import Language from "./Profile/Language"

export default function ControllerConfig(languages) {
	return {
		language: Language(languages),

		identity: {
		},

		"identity.birthday": {
			display: "none"
		},

		skills: {

		},

		profile: {
			
		}
	}
}